import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Guide from "../pages/guide/page";
import Review from "../pages/review/page";
import Shipping from "../pages/shipping/page";
import Safety from "../pages/safety/page";
import Coupon from "../pages/coupon/page";
import Beginner from "../pages/beginner/page";
import Haul from "../pages/haul/page";
import QC from "../pages/qc/page";
import Compare from "../pages/compare/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <Guide />,
  },
  {
    path: "/sugargoo-review-2026",
    element: <Review />,
  },
  {
    path: "/sugargoo-shipping-guide",
    element: <Shipping />,
  },
  {
    path: "/sugargoo-safety-legit",
    element: <Safety />,
  },
  {
    path: "/sugargoo-coupon-guide",
    element: <Coupon />,
  },
  {
    path: "/sugargoo-beginner-tutorial",
    element: <Beginner />,
  },
  {
    path: "/sugargoo-haul-guide",
    element: <Haul />,
  },
  {
    path: "/sugargoo-qc-guide",
    element: <QC />,
  },
  {
    path: "/sugargoo-vs-alternatives",
    element: <Compare />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;